(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("stream"), require("fs"));
	else if(typeof define === 'function' && define.amd)
		define(["stream", "fs"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("stream"), require("fs")) : factory(root["stream"], root["fs"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_256__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition